import { FormControlLabel, styled } from '@mui/material';

export const FormControlLabelStyled = styled(FormControlLabel)(() => ({
  '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
    fontSize: '14px',
  },
}));
